export default __webpack_public_path__ + "static/5_20-eabf4d30eea21b775069c73b5b6bbf90.png";